import { NSARouterMakerResult } from "namirasoft-account-react";
import { FieldEntities } from "../FieldEntities";
import { FieldLayout } from "../FieldLayout";
import { FieldProps } from "../FieldProps";

interface SlotViewPageProps extends NSARouterMakerResult, FieldProps { }

export default function SlotViewPage(props: SlotViewPageProps)
{
	return (
		<FieldLayout
			{...props}
			action={{
				description: "This section displays detailed information about a selected slot."
			}}
			pages={{
				entity: FieldEntities.slot(props),
				view: {}
			}}
		>
			<> </>
		</FieldLayout>
	);
}